import React, {useEffect} from 'react';
import logo from './logo.svg';
import './App.css';
import {MetaTags} from "./components/common/utilities";
import {useTranslation} from "react-i18next";
import MobilitusFooter from "./components/common/mobilitusFooter";

function App()
{
    const {t, i18n}: any = useTranslation('dashboard');

    const stopBouncing = () => {
        const el = document.getElementById("promo-icon");
        if (el)
        {
            el.classList.remove("animate-bounce");
        }
    }

    useEffect(() => {
        setTimeout(() => stopBouncing(), 3500)
        //getPhotos();
        i18n.changeLanguage(navigator.language.split('-')[0]);

    }, []);

    return (

        <><MetaTags
            title='The AI Filtered Event Database'
            description='Get Started!'
            image='https://promogogo.com/cdn-cgi/image/fit=contain,width=768/https://media.promogogo.com/ymsirvidburdir/2024-06-10/3666078aaa094262b626960bf705498b.png'
            name='Team Mobilitus'/>
            <div className="min-h-screen flex flex-col">
                {/* Header or main content */}
                <main className="flex-grow">
                    <div className="bg-white">
                        <div className="px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
                            <div className="mx-auto max-w-2xl text-center ">
                                <div className="flex justify-center">
                                    <img id="promo-icon"
                                         className="h-16 w-auto animate-bounce"
                                         src="https://media.promogogo.com/ymsirvidburdir/2025-03-13/ymsirvidburdir-78662c7e-34ad-47cd-83fe-f73fbea5e36b-promo_heart_yellow_256px.png"
                                         alt="Promogogo"/>
                                </div>
                                <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl uppercase mt-4">
                                    {t('frontpageheadline')}

                                </h2>

                                <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-600">
                                    {t('uptodateeventinfo')}
                                </p>
                                <div className="mt-10 flex items-center justify-center gap-x-6">
                                    <a
                                        href="/dashboard"
                                        className="rounded-md bg-orange-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                    >
                                        {t('dashboard')}

                                    </a>
                                    <a href="/gettingstarted"
                                       className="rounded-md bg-pg_green px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-pg_blue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700">
                                        {t('getstarted')}

                                    </a>
                                </div>
                            </div>
                            <div className="mt-2 text-center text-sm leading-5 text-gray-600 max-w">
                                <br/>
                                using server {process.env.REACT_APP_API_URL}</div>
                        </div>
                    </div>

                    <div className="bg-white ">
                        <div className="mx-auto max-w-7xl px-6 lg:px-8">

                            <div
                                className="mx-auto mt-2 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">

                                <article className="flex flex-col items-start justify-between">
                                    <div className="relative w-full">
                                        <img
                                            alt=""
                                            src={'https://promogogo.com/cdn-cgi/image/fit=contain,width=768/https://media.promogogo.com/ymsirvidburdir/2025-04-20/ymsirvidburdir-edd27e47-10af-484e-bf77-f2ea72078c3f-fillallseats.png'}
                                            className="aspect-video w-full rounded-2xl bg-gray-100 object-cover "
                                        />
                                        <div
                                            className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10"/>
                                    </div>
                                    <div className="max-w-xl">
                                        <div className="mt-8 flex items-center gap-x-4 text-xs">


                                            {t('forvenues')}


                                        </div>
                                        <div className="group relative">
                                            <h3 className="mt-3 text-lg/6 font-semibold text-gray-900 group-hover:text-gray-600">

                                                <span className="absolute inset-0"/>
                                                {t('forvenuestitle')}


                                            </h3>
                                            <p className="mt-5 line-clamp-3 text-sm/6 text-gray-600">
                                                {t('forvenuesslug')}
                                            </p>
                                        </div>

                                    </div>
                                </article>

                                <article className="flex flex-col items-start justify-between">
                                    <div className="relative w-full">
                                        <img
                                            alt=""
                                            src={'https://promogogo.com/cdn-cgi/image/fit=contain,width=768/https://media.promogogo.com/ymsirvidburdir/2025-04-20/ymsirvidburdir-913c441c-ffe0-4ad6-b209-5ece9e686c64-on-the-road-again.png'}
                                            className="aspect-video w-full rounded-2xl bg-gray-100 object-cover "
                                        />
                                        <div
                                            className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10"/>
                                    </div>
                                    <div className="max-w-xl">
                                        <div className="mt-8 flex items-center gap-x-4 text-xs">


                                            {t('forperformers')}


                                        </div>
                                        <div className="group relative">
                                            <h3 className="mt-3 text-lg/6 font-semibold text-gray-900 group-hover:text-gray-600">

                                                <span className="absolute inset-0"/>
                                                {t('forperformerstitle')}


                                            </h3>
                                            <p className="mt-5 line-clamp-3 text-sm/6 text-gray-600">
                                                {t('forperformersslug')}

                                            </p>
                                        </div>

                                    </div>
                                </article>

                                <article className="flex flex-col items-start justify-between">
                                    <div className="relative w-full">
                                        <img
                                            alt=""
                                            src={'https://promogogo.com/cdn-cgi/image/fit=contain,width=768/https://media.promogogo.com/ymsirvidburdir/2025-04-20/ymsirvidburdir-06a1a46a-3aea-48e8-8b51-9170fe827ca6-event-ads-and-listings.png'}
                                            className="aspect-video w-full rounded-2xl bg-gray-100 object-cover "
                                        />
                                        <div
                                            className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10"/>
                                    </div>
                                    <div className="max-w-xl">
                                        <div className="mt-8 flex items-center gap-x-4 text-xs">


                                            {t('formedia')}


                                        </div>
                                        <div className="group relative">
                                            <h3 className="mt-3 text-lg/6 font-semibold text-gray-900 group-hover:text-gray-600">

                                                <span className="absolute inset-0"/>
                                                {t('formediatitle')}


                                            </h3>
                                            <p className="mt-5 line-clamp-3 text-sm/6 text-gray-600">
                                                {t('formediaslug')}

                                            </p>
                                        </div>

                                    </div>
                                </article>

                            </div>
                        </div>
                    </div>
                </main>
                <MobilitusFooter/>
            </div>
        </>);
}

export default App;
